import { useEffect, useState } from 'react';

/**
 * Custom hook to track the current URL hash fragment.
 *
 * @returns The current hash fragment as a string (including the '#' symbol).
 */
const useHash = (): string => {
  // Initialize the state with the current hash or an empty string
  const [hash, setHash] = useState<string>(typeof window !== 'undefined' ? window.location.hash : '');

  useEffect(() => {
    // Handler for hash change events
    const handleHashChange = () => {
      setHash(window.location.hash);
    };

    // Add event listener for hash changes
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return hash;
};

export default useHash;
